export default __webpack_public_path__ + "static/media/Artboard1.a8cd55c7.png";